'use client'

import React, { useContext } from 'react'
import * as S from './Textarea.styles'

import { Paragraph } from '../../../atoms/Typography/Typography.component'
import { SpacerBase } from '../../../atoms/GridSystem'
import { useField } from 'formik'
import { SectionThemeContext } from '../../../../contexts/SectionTheme.context'

type TextareaProps = {
  label?: string
  name: string
  id?: string
  placeholder?: string
  required?: boolean
  'aria-required'?: boolean
  'aria-describedby'?: string
  withBackground?: boolean
}

function Textarea({ label, withBackground, ...props }: TextareaProps) {
  const [field, meta] = useField(props)
  const { selectedColorScheme } = useContext(SectionThemeContext)
  const hasError = meta.touched && !!meta.error
  const errorId = `${props.name}-error`

  return (
    <>
      <S.Textarea colorScheme={selectedColorScheme} withBackground={withBackground}>
        {label ? (
          <Paragraph typo="paragraphXS" as="label" htmlFor={props.id || props.name}>
            {label + (props?.required ? ' *' : '')}
          </Paragraph>
        ) : null}
        <textarea
          {...field}
          {...props}
          id={props.id || props.name}
          placeholder={props.placeholder}
          aria-invalid={hasError}
          aria-describedby={hasError ? errorId : undefined}
        />
      </S.Textarea>
      {hasError ? (
        <S.TextareaError id={errorId} role="alert">
          <SpacerBase xs={1} />
          {meta.error}
        </S.TextareaError>
      ) : null}
    </>
  )
}

export default Textarea
